<template>
  <section
    id="merit"
    class="co-bg-striped"
  >
    <div class="co-container-sm py-12 text-center sm:py-16">
      <div class="mb-12 px-4">
        <h2 class="co-display-7 mb-4 tracking-[.15em]">
          利用するメリット
        </h2>
        <p class="text-co-gray-600">
          <span class="inline md:block">学習と平行して転職活動ができるテックアカデミー受講生限定の無料サービスです。</span>
          <span class="inline md:block">今すぐ転職をお考えでない方でもお気軽にご利用になれます。</span>
        </p>
      </div>
      <div class="mx-4 text-left lg:mx-0">
        <div class="mb-5 bg-co-gray-200 p-5 shadow-[0_0_4px_rgba(51,51,51,0.2)] md:flex">
          <div class="te-photo-wrap mb-5 md:mb-0">
            <img
              src="~/assets/images/Te/TeCareerAbout/Index/Merit/career-merit-photo-1.jpg"
              class="w-full"
              alt="質の良い求人やスカウトが届く"
              loading="lazy"
            >
          </div>
          <div class="md:ml-5">
            <h3 class="te-merit-title co-display-10 mb-5">
              質の良い求人やスカウトが届く
            </h3>
            <p class="co-display-13">
              テックアカデミーキャリアの求人案件やコンサルタントが紹介する企業はIT業界の中でも伸びているサービスを提供する成長中の企業ばかり。<br>どこの企業 / コンサルタントもITスキルや知識を持つ人を積極的に探しているため、思いがけないスカウトが届くかもしれません。
            </p>
          </div>
        </div>
        <div class="mb-5 flex-row-reverse bg-co-gray-200 p-5 shadow-[0_0_4px_rgba(51,51,51,0.2)] md:flex">
          <div class="te-photo-wrap mb-5 md:mb-0">
            <img
              src="~/assets/images/Te/TeCareerAbout/Index/Merit/career-merit-photo-2.jpg"
              class="w-full"
              alt="学習を進めるだけで転職が有利に"
              loading="lazy"
            >
          </div>
          <div class="md:mr-5">
            <h3 class="te-merit-title co-display-10 mb-5">
              学習を進めるだけで転職が有利に
            </h3>
            <p class="co-display-13">
              テックアカデミーでの学習状況は企業やコンサルタントに共有されます。そのため、学習を進めていただくだけでご自身をアピールすることにも繋がります。また、テックアカデミーキャリアはテックアカデミーをご受講と同時にご利用になれますので、学習と転職活動を同時に行う事も可能となっております。
            </p>
          </div>
        </div>
        <div class="mb-5 bg-co-gray-200 p-5 shadow-[0_0_4px_rgba(51,51,51,0.2)] md:flex">
          <div class="te-photo-wrap mb-5 md:mb-0">
            <img
              src="~/assets/images/Te/TeCareerAbout/Index/Merit/career-merit-photo-3.jpg"
              class="w-full"
              alt="自身の市場価値がわかる"
              loading="lazy"
            >
          </div>
          <div class="md:ml-5">
            <h3 class="te-merit-title co-display-10 mb-5">
              自身の市場価値がわかる
            </h3>
            <p class="co-display-13">
              転職に成功している人は平均して 4〜5名のコンサルタントを活用しています。<br>テックアカデミーキャリアは経験豊富なコンサルタントが登録しており、あなたに最適なスカウトや求人を送ります。どのような企業やポジションのスカウトが届くかで自ずと自分の採用ニーズや市場価値がわかります。
            </p>
          </div>
        </div>
        <div class="mb-5 flex-row-reverse bg-co-gray-200 p-5 shadow-[0_0_4px_rgba(51,51,51,0.2)] md:flex">
          <div class="te-photo-wrap mb-5 md:mb-0">
            <img
              src="~/assets/images/Te/TeCareerAbout/Index/Merit/career-merit-photo-4.jpg"
              class="w-full"
              alt="スキルを活かせる環境へ転職"
              loading="lazy"
            >
          </div>
          <div class="md:mr-5">
            <h3 class="te-merit-title co-display-10 mb-5">
              スキルを活かせる環境へ転職
            </h3>
            <p class="co-display-13">
              テックアカデミーで身につけたスキルは仕事に直結するスキルでもあります。<br>今や、IT関連の企業はどこも人手不足の状態でITスキルを持った人の採用活動は活発に行われています。<br>キャリアアップや新しいキャリアのファーストステップに、当サービスをお役立てください。
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.te-photo-wrap {
  width: 281px;
}

@media (max-width: 767.98px) {
  .te-photo-wrap {
    width: 100%;
  }
}

.te-photo-wrap img {
  min-width: 281px !important;
}

@media (max-width: 767.98px) {
  .te-merit-title {
    font-size: 1rem;
  }
}

@media (max-width: 575.98px) {
  .te-merit-title {
    font-size: 0.875rem;
    font-weight: bold;
  }
}
</style>
